import { NotificationsFollowButton as NotificationsFollowButtonComponent } from './NotificationsFollowButton'

export default NotificationsFollowButtonComponent

export * from './NotificationsFollowButton'
